import axios from 'axios'

import { API_URL } from 'config'
import { logout } from 'UserApp/store/user/actions'

const request = axios.create({
  baseURL: API_URL || '/',
  withCredentials: true,
})

request.interceptors.request.use((config) => {
  if (config.data) {
    return {
      ...config,
      data: { data: config.data },
    }
  } else {
    return config
  }
})

request.interceptors.response.use(
  (response) => {
    const { data, ...rest } = response

    return {
      ...rest,
      data: data.data,
    }
  },
  (error) => {
    if (error.response?.status === 401) {
      logout()
      window.location.href = '/signin'
      return Promise.reject(new Error('Unauthorized'))
    }

    const message =
      error.response?.data?.errors?.[0]?.detail ??
      error.response?.data?.errors?.[0]?.title ??
      error.response?.data?.message ??
      'Something went wrong'
    return Promise.reject(new Error(message))
  },
)

export default request
